import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { ModuleVersionProviderDependencyRow } from "../types";

const ModuleVersionDependenciesTableDropdownCell = ({
  ...cellProps
}: TableSimpleCellProps<ModuleVersionProviderDependencyRow>) => {
  return <TableSimpleCell {...cellProps} />;
};

export default ModuleVersionDependenciesTableDropdownCell;
